import paths from '../paths';
import { KisaanClient } from './axiosKisaanClient';
import { IAnimalPreferenceResponse, ICategoryResponse, ICropByCategoryResponse } from './interface';
export const categoryListApi = async () => {
  try {
    const response = await KisaanClient.get<ICategoryResponse>(paths.getCategoryList());
    return response?.data;
  } catch (e) {
    console.error('Error fetching cropType:', e);
  }
};

export const cropsByCategoryListApi = async (
  config: number
): Promise<ICropByCategoryResponse | undefined> => {
  try {
    const response = await KisaanClient.get<ICropByCategoryResponse>(
      paths.getCropsbyCategoryList(config)
    );
    return response?.data ?? undefined;
  } catch (error) {
    console.error('Error fetching crop by cropType:', error);
  }
};

export const getCategoryData = async (): Promise<ICategoryResponse | undefined> => {
  try {
    const response: ICategoryResponse | undefined = await categoryListApi();
    if (response) {
      return response;
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
  }
};

export const getCropsByCategories = async (
  categoryId: number
): Promise<ICropByCategoryResponse | undefined> => {
  try {
    const response: ICropByCategoryResponse | undefined = await cropsByCategoryListApi(categoryId);
    if (response) {
      return response;
    }
  } catch (error) {
    console.error('Error fetching crops by category:', error);
  }
};

export const animalListApi = async (): Promise<IAnimalPreferenceResponse> => {
  try {
    const response = await KisaanClient.get<IAnimalPreferenceResponse>(paths.getAnimalsList());
    return response?.data;
  } catch (e) {
    console.error('Error fetching AnimalList:', e);
    return { data: [] };
  }
};
